import { render } from "./App.html?vue&type=template&id=25edfd4a&ts=true&external"
import script from "./App.ts?vue&type=script&lang=ts&external"
export * from "./App.ts?vue&type=script&lang=ts&external"

import "./App.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__